import agent from "../../../api/agent";

export const list = (pagerInputModel) =>  agent.requests.post(`/Task/getlist`, pagerInputModel);

export const create = (Task)        => agent.requests.post(`/Task/create`, Task);



export const update = (Task)        => agent.requests.post(`Task/update`, Task);



export const getProjectUsers = (pUsr)  => agent.requests.post(`ProjectUser/GetList`, pUsr);



